const translations = {
  // Navbar
  nav_home: 'Ana Sayfa',
  nav_about: 'Hakkımızda',
  nav_electrical: 'Elektrik',
  nav_construction: 'İnşaat',
  nav_projects: 'Projeler',
  nav_contact: 'İletişim',
  nav_quote: 'Teklif Al',

  // Hero
  hero_slide1_tag: 'Elektrik Mühendisliği',
  hero_slide1_title: "Türkiye'nin Önde Gelen Endüstriyel Tesislerine Güç Veriyoruz",
  hero_slide1_subtitle: 'Orta ve alçak gerilim sistemleri, zayıf akım ve endüstriyel otomasyon alanlarında anahtar teslim çözümler sunuyoruz.',
  hero_slide2_tag: 'Anahtar Teslim İlaç Fabrikaları',
  hero_slide2_title: 'GMP Standartlarında İlaç Tesislerine Özel Uygulamalar',
  hero_slide2_subtitle: '30 yıllık tecrübemizle, ilaç üretim tesislerinde standartlara tam uyumlu elektrik ve otomasyon sistemleri hayata geçiriyoruz.',
  hero_slide3_tag: 'Savunma & İlaç',
  hero_slide3_title: 'TAI, Aselsan ve\nAbdi İbrahim Referanslarıyla',
  hero_slide3_subtitle: 'Sektörün önde gelen sanayi kuruluşlarında edindiğimiz saha deneyimiyle, endüstriyel tesislerin elektrik altyapılarını güvenle uyguluyoruz.',
  hero_cta_projects: 'Projelerimizi İnceleyin',
  hero_cta_contact: 'Bize Ulaşın',

  // Stats
  stats_years: 'Yıllık Deneyim',
  stats_area: 'Tamamlanan Proje Alanı',
  stats_projects: 'Başarılı Proje',
  stats_engineers: 'Çalışan Sayısı',

  // Services
  services_label: 'Ne Yapıyoruz',
  services_title: 'Kapsamlı Mühendislik Çözümleri',
  services_desc: "Orta gerilim elektrik sistemlerinden eksiksiz anahtar teslim inşaata kadar Türkiye'nin en zorlu sektörleri için uçtan uca mühendislik çözümleri sunuyoruz.",
  services_electrical_title: 'Elektrik Hizmetleri',
  services_construction_title: 'İnşaat Hizmetleri',
  services_view_all: 'Tümünü Gör',
  svc_mv_title: 'Orta Gerilim Sistemleri',
  svc_mv_desc: 'Güç iletim hatları, trafo merkezi projeleri, şalt sistemleri, transformatörler ve dağıtım merkezleri.',
  svc_lv_title: 'Alçak Gerilim Sistemleri',
  svc_lv_desc: 'İç/dış mekan aydınlatma, güç tesisatı, topraklama ve UPS sistem kurulumları.',
  svc_weak_title: 'Zayıf Akım & Güvenlik',
  svc_weak_desc: 'Yangın algılama, CCTV, erişim kontrolü, interkom ve anons sistemleri.',
  svc_auto_title: 'Otomasyon & Kontrol',
  svc_auto_desc: 'Anahtar teslim proses otomasyonu, PLC tabanlı sistemler, SCADA ve enerji izleme/yönetimi.',
  svc_rough_title: 'Kaba İnşaat',
  svc_rough_desc: 'Temel işleri, betonarme, taşıyıcı sistemler, çatı ve cephe uygulamaları.',
  svc_finish_title: 'İnce İşler & Mimari',
  svc_finish_desc: 'İç mekan ince işleri, zemin kaplamaları, boya, marangozluk ve alçıpan bölmeler.',
  svc_ext_title: 'Dış Mekan İşleri',
  svc_ext_desc: 'Kaplama, dış cephe yalıtımı ve eksiksiz proje teslimi için peyzaj düzenlemesi.',
  svc_pm_title: 'Proje Yönetimi',
  svc_pm_desc: 'Saha etüdü, maliyet analizi, planlama ve tam uygulama koordinasyonu.',

  // Projects
  projects_label: 'Portföyümüz',
  projects_title: 'Öne Çıkan Projeler',
  projects_view_all: 'Tüm Projeleri Gör',
  projects_cat_all: 'Tümü',
  projects_cat_pharma: 'İlaç',
  projects_cat_defense: 'Savunma Sanayii',
  projects_cat_infra: 'Altyapı',
  projects_cat_health: 'Sağlık',
  projects_cat_industrial: 'Endüstriyel Üretim',
  projects_cat_textile: 'Tekstil',
  projects_view_detail: 'Detayları Gör',
  projects_view_detail_btn: 'Detayları Gör',

  // About
  about_label: 'Hakkımızda',
  about_title: "1996'dan Bu Yana Türkiye'nin Güvenilir EPC Ortağı",
  about_p1: "Canel Elektrik İnşaat Taahhüt Mühendislik, İstanbul Perpa Ticaret Merkezi'nde faaliyet gösteren önde gelen bir Mühendislik, Tedarik ve İnşaat (EPC) firmasıdır. Yaklaşık otuz yıllık deneyimimizle Türkiye'nin en kritik ve karmaşık tesisleri için kapsamlı elektrik taahhüt çözümleri sunmaktayız.",
  about_p2: "Portföyümüz; ilaç, savunma sanayi, havacılık, sağlık ve endüstriyel tesis sektörlerinde 1.250.000 m²'yi aşan tamamlanmış projeleri kapsamakta olup Abdi İbrahim, TAI ve Aselsan gibi önemli referansları içermektedir.",
  about_cta: 'Hakkımızda Daha Fazla Bilgi',
  about_h1_title: 'ISO Sertifikalı',
  about_h1_desc: 'Kalite yönetim sistemleri uluslararası standartlara göre sertifikalandırılmıştır.',
  about_h2_title: 'Uzman Ekip',
  about_h2_desc: 'On yıllarca deneyime sahip yüksek nitelikli mühendisler ve proje yöneticileri.',
  about_h3_title: '3D Modelleme',
  about_h3_desc: 'Gelişmiş 3D planlama, sahada herhangi bir çalışma başlamadan önce hassasiyeti garanti eder.',
  about_h4_title: 'As-Built Belgeler',
  about_h4_desc: 'Proje tamamlandığında ayrıntılı as-built dokümantasyon teslim edilmektedir.',
  about_industries_label: 'Hizmet Verdiğimiz Sektörler',
  ind_pharma: 'İlaç',
  ind_defense: 'Savunma',
  ind_aerospace: 'Havacılık',
  ind_health: 'Sağlık',
  ind_infra: 'Altyapı',
  ind_industrial: 'Endüstriyel',
  ind_hospitality: 'Konaklama',
  ind_education: 'Eğitim',

  // Contact
  contact_label: 'İletişime Geçin',
  contact_title: 'Birlikte Harika Bir Şey İnşa Edelim',
  contact_desc: 'Elektrik mühendisliği, anahtar teslim inşaat veya özel tesis çözümlerine ihtiyaç duyuyor olun — ekibimiz teslim etmeye hazır.',
  contact_address_label: 'Adres',
  contact_address_val: 'Perpa Ticaret Merkezi, A Blok Kat: 5 No: 204\nOkmeydanı, Şişli / İstanbul, Türkiye',
  contact_phone_label: 'Telefon',
  contact_email_label: 'E-posta',

  // Navbar
  navbar_subtitle: 'Elektrik & İnşaat',

  // About Page
  about_story_label: 'HİKAYEMİZ',
  about_story_title: '30+ Yıllık Mühendislik Mirası',
  about_timeline_label: 'Tarihçe',
  about_timeline_title: 'Kilometre Taşlarımız',
  about_certs_label: 'Kalite',
  about_certs_title: 'Sertifikalarımız',
  about_team_label: 'Ekibimiz',
  about_team_title: 'Liderlik Kadrosu',
  cert_iso9001_desc: 'Kalite Yönetim Sistemi',
  cert_iso14001_desc: 'Çevre Yönetim Sistemi',
  cert_iso45001_desc: 'İş Sağlığı ve Güvenliği',
  cert_tse_desc: 'Türk Standartları Enstitüsü',
  tl_1996_title: 'Kuruluş',
  tl_1996_desc: 'Canel Elektrik, İstanbul Perpa Ticaret Merkezi\'nde kuruldu.',
  tl_2007_title: 'Metro Projesi',
  tl_2007_desc: 'Şişhane–Beyoğlu metro altyapı projesi başarıyla tamamlandı.',
  tl_2008_title: 'Savunma Sanayi',
  tl_2008_desc: 'ASELSAN ve TAI ile savunma sanayi projeleri başlatıldı.',
  tl_2018_title: 'Biyoteknoloji Projesi',
  tl_2018_desc: 'AbdiBio biyoteknoloji tesisi projesi tamamlandı.',
  tl_2022_title: 'Yeni Üretim Tesisi',
  tl_2022_desc: 'Abdi İbrahim Yeni Üretim Tesisi (YÜT) resmi olarak faaliyete geçti.',
  tl_2026_title: '1.250.000+ m²',
  tl_2026_desc: 'Toplam tamamlanan proje alanı 1.250.000 m²\'yi aştı.',
  about_refprojects_label: 'Projeler',
  about_refprojects_title: 'Referans Projelerimiz',
  team_role_ceo: 'Genel Müdür',
  team_role_elec: 'Elektrik Proje Müdürü',
  team_role_con: 'İnşaat Proje Müdürü',
  team_role_auto: 'Otomasyon Mühendisi',

  // Contact Page
  contact_hours_label: 'Çalışma Saatleri',
  contact_hours_weekdays: 'Pzt – Cum: 09:00 – 18:00',
  contact_hours_saturday: 'Cumartesi: 09:00 – 12:00',
  get_directions: 'Yol Tarifi Al',

  // Electrical Page
  elec_hero_subtitle: 'Orta gerilimden otomasyon sistemlerine kadar eksiksiz elektrik mühendisliği çözümleri.',
  elec_detail_mv1: 'Enerji iletim hatları',
  elec_detail_mv2: 'Trafo merkezi projeleri',
  elec_detail_mv3: 'Şalt sistemleri',
  elec_detail_mv4: 'Transformatörler',
  elec_detail_mv5: 'Dağıtım merkezleri',
  elec_detail_mv6: 'Kompanzasyon sistemleri',
  elec_detail_lv1: 'İç/dış mekan aydınlatma',
  elec_detail_lv2: 'Güç tesisatı',
  elec_detail_lv3: 'Topraklama sistemleri',
  elec_detail_lv4: 'UPS kurulumları',
  elec_detail_lv5: 'Pano imalatı',
  elec_detail_lv6: 'Kablo döşeme',
  elec_detail_weak1: 'Yangın algılama sistemleri',
  elec_detail_weak2: 'CCTV & güvenlik kameraları',
  elec_detail_weak3: 'Erişim kontrol sistemleri',
  elec_detail_weak4: 'İnterkom sistemleri',
  elec_detail_weak5: 'Anons sistemleri',
  elec_detail_weak6: 'Yapısal kablolama',
  elec_detail_auto1: 'Anahtar teslim proses otomasyonu',
  elec_detail_auto2: 'PLC tabanlı kontrol sistemleri',
  elec_detail_auto3: 'SCADA sistemleri',
  elec_detail_auto4: 'Enerji izleme & yönetimi',
  elec_detail_auto5: 'MCC panoları',
  elec_detail_auto6: 'Saha enstrümantasyonu',
  cta_title: 'Projeniz için teklif alın',
  cta_desc: 'Uzman ekibimiz ihtiyaçlarınızı değerlendirip en uygun çözümü sunar.',

  // Construction Page
  con_hero_subtitle: 'Temelden çatıya anahtar teslim inşaat çözümleri.',
  con_detail_rough1: 'Temel kazı ve beton işleri',
  con_detail_rough2: 'Betonarme taşıyıcı sistemler',
  con_detail_rough3: 'Çelik konstrüksiyon',
  con_detail_rough4: 'Çatı sistemleri',
  con_detail_rough5: 'Cephe uygulamaları',
  con_detail_rough6: 'Su yalıtımı',
  con_detail_finish1: 'İç mekan ince işleri',
  con_detail_finish2: 'Zemin kaplamaları',
  con_detail_finish3: 'Boya ve badana',
  con_detail_finish4: 'Marangozluk işleri',
  con_detail_finish5: 'Alçıpan bölmeler',
  con_detail_finish6: 'Asma tavan sistemleri',
  con_detail_ext1: 'Dış cephe kaplama',
  con_detail_ext2: 'Isı yalıtımı',
  con_detail_ext3: 'Peyzaj düzenlemesi',
  con_detail_ext4: 'Yol ve altyapı',
  con_detail_ext5: 'Çevre düzenlemesi',
  con_detail_ext6: 'Aydınlatma',
  con_detail_pm1: 'Saha etüdü ve fizibilite',
  con_detail_pm2: 'Maliyet analizi',
  con_detail_pm3: 'İş programı hazırlama',
  con_detail_pm4: 'Kalite kontrol',
  con_detail_pm5: 'Raporlama',
  con_detail_pm6: 'Teslim ve dokümantasyon',

  // Partners
  partners_label: 'Ortaklarımız',
  partners_title: 'Çözüm Ortaklarımız',

  // Footer
  footer_tagline: 'Mühendislik, Tedarik & İnşaat. İstanbul, Türkiye. Kuruluş: 1996.',
  footer_services: 'HİZMETLER',
  footer_company: 'ŞİRKET',
  footer_contact: 'İLETİŞİM',
  footer_about: 'Hakkımızda',
  footer_projects: 'Projeler',
  footer_catalog: 'E-Katalog',
  footer_careers: 'Kariyer',
  footer_privacy: 'Gizlilik Politikası',
  footer_terms: 'Kullanım Koşulları',
  footer_copyright: '© 2024 Canel Elektrik İnşaat Taahhüt Mühendislik. Tüm hakları saklıdır.',
};

export default translations;
